"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

export const ScrollRestoration = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // Ensure every route navigation starts at the top without auto-scrolling to any section
  useEffect(() => {
    if (typeof window !== "undefined" && !window.location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, searchParams]);

  return null;
};
